/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { ID } from '@gh/common-shared-data';
import { createEnum, EnumSet } from '@gh/core-data';
import { isEmpty, isNil, sortBy } from 'lodash';

// tslint:disable-next-line:variable-name
export const FormulaElementGroup = createEnum('FORMULA_ELEMENTS_GROUP', {
  MathFunctions: 'MATH_FUNCTIONS',
  Operators: 'OPERATORS',
  TakeOffParams: 'TAKE_OFF_PARAMS',
  TrigFunctions: 'TRIG_FUNCTIONS',
});

export type FormulaElementGroup = EnumSet<typeof FormulaElementGroup>;

export interface Formula {
  expression: string;
  takeOffParams: ID[];
  valid: boolean;
}

export type FormulaDto = Formula;

const FORMULA_PARAM_RE = /\$TOP_WITH_ID_(\w+)\$/g;

export function isFormulaEmpty(formula?: Formula): boolean {
  return isNil(formula) ? true : isEmpty(formula.expression);
}

export function isFormulaValid(formula: Formula): boolean {
  return formula.valid;
}

export function substituteFormulaParams(expression: string, substitutor: (topId: ID) => string): string {
  return expression.replace(FORMULA_PARAM_RE, (_: string, topId: string) => substitutor(topId));
}

export function getFormulaParams(expression: string): ID[] {
  const params: ID[] = [];

  while (true) {
    const match = FORMULA_PARAM_RE.exec(expression);

    if (match) {
      params.push(match[1]);
    } else {
      break;
    }
  }

  return normalizeTakeOffParams(params);
}

export function createFormulaModel(expression: string, takeOffParams: ID[], valid: boolean): Formula {
  return { expression, takeOffParams, valid };
}

export function normalizeTakeOffParams(ids: ID[]): ID[] {
  return sortBy(ids);
}
